import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AttributeType, gl } from '@antv/l7-core';
import { generateColorRamp, getMask } from '@antv/l7-utils';
import { isEqual } from 'lodash';
import BaseModel from "../../core/BaseModel";
import { RasterImageTriangulation } from "../../core/triangulation";

/* babel-plugin-inline-import '../shaders/dataImage_frag.glsl' */
var ImageFrag = "precision mediump float;\nuniform float u_opacity: 1.0;\n\nuniform sampler2D u_texture;\nuniform sampler2D u_colorTexture;\n\nvarying vec2 v_texCoord;\n\nuniform vec2 u_domain;\nuniform float u_noDataValue;\nuniform bool u_clampLow: true;\nuniform bool u_clampHigh: true;\n\nuniform float u_pixelConstant;\nuniform float u_pixelConstantR;\nuniform float u_pixelConstantG;\nuniform float u_pixelConstantB;\nuniform float u_pixelConstantRGB;\n\nvoid main() {\n  vec4 baseColor = texture2D(u_texture, vec2(v_texCoord.x, v_texCoord.y));\n\n  float r = baseColor.r;\n  float g = baseColor.g;\n  float b = baseColor.b;\n\n  float value = u_pixelConstant + ((r * u_pixelConstantR + g * u_pixelConstantG + b * u_pixelConstantB) * u_pixelConstantRGB);\n  if (value == u_noDataValue) {\n    gl_FragColor = vec4(0.0, 0, 0, 0.0);\n  } else if ((!u_clampLow && value < u_domain[0]) || (!u_clampHigh && value > u_domain[1])) {\n    gl_FragColor = vec4(0, 0, 0, 0);\n  } else {\n    float normalisedValue =(value - u_domain[0]) / (u_domain[1] - u_domain[0]);\n    vec4 color = texture2D(u_colorTexture, vec2(normalisedValue, 0));\n    gl_FragColor = color;\n    gl_FragColor.a =  gl_FragColor.a * u_opacity ;\n  }\n}\n";

/* babel-plugin-inline-import '../shaders/image_vert.glsl' */
var ImageVert = "precision highp float;\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_Mvp;\nattribute vec3 a_Position;\nattribute vec2 a_Uv;\nvarying vec2 v_texCoord;\n#pragma include \"projection\"\nvoid main() {\n   v_texCoord = a_Uv;\n   vec4 project_pos = project_position(vec4(a_Position, 1.0));\n   // gl_Position = project_common_position_to_clipspace(vec4(project_pos.xy,0., 1.0));\n   if(u_CoordinateSystem == COORDINATE_SYSTEM_P20_2) { // gaode2.x\n      gl_Position = u_Mvp * (vec4(project_pos.xy,0., 1.0));\n   } else {\n      gl_Position = project_common_position_to_clipspace(vec4(project_pos.xy,0., 1.0));\n   }\n}\n";

var ImageDataModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(ImageDataModel, _BaseModel);

  var _super = _createSuper(ImageDataModel);

  function ImageDataModel() {
    _classCallCheck(this, ImageDataModel);

    return _super.apply(this, arguments);
  }

  _createClass(ImageDataModel, [{
    key: "getUninforms",
    value: function getUninforms() {
      var _ref = this.layer.getLayerConfig(),
          opacity = _ref.opacity,
          _ref$clampLow = _ref.clampLow,
          clampLow = _ref$clampLow === void 0 ? true : _ref$clampLow,
          _ref$clampHigh = _ref.clampHigh,
          clampHigh = _ref$clampHigh === void 0 ? true : _ref$clampHigh,
          _ref$noDataValue = _ref.noDataValue,
          noDataValue = _ref$noDataValue === void 0 ? -9999999 : _ref$noDataValue,
          _ref$domain = _ref.domain,
          domain = _ref$domain === void 0 ? [0, 1] : _ref$domain,
          rampColors = _ref.rampColors,
          _ref$pixelConstant = _ref.pixelConstant,
          pixelConstant = _ref$pixelConstant === void 0 ? 0.0 : _ref$pixelConstant,
          _ref$pixelConstantR = _ref.pixelConstantR,
          pixelConstantR = _ref$pixelConstantR === void 0 ? 256 * 256 : _ref$pixelConstantR,
          _ref$pixelConstantG = _ref.pixelConstantG,
          pixelConstantG = _ref$pixelConstantG === void 0 ? 256 : _ref$pixelConstantG,
          _ref$pixelConstantB = _ref.pixelConstantB,
          pixelConstantB = _ref$pixelConstantB === void 0 ? 1 : _ref$pixelConstantB,
          _ref$pixelConstantRGB = _ref.pixelConstantRGB,
          pixelConstantRGB = _ref$pixelConstantRGB === void 0 ? 0.1 : _ref$pixelConstantRGB;

      if (!isEqual(this.rampColors, rampColors)) {
        this.updateColorTexture();
        this.rampColors = rampColors;
      }

      return {
        u_opacity: opacity || 1,
        u_texture: this.texture,
        u_pixelConstant: pixelConstant,
        u_pixelConstantR: pixelConstantR,
        u_pixelConstantG: pixelConstantG,
        u_pixelConstantB: pixelConstantB,
        u_pixelConstantRGB: pixelConstantRGB,
        u_domain: domain,
        u_clampLow: clampLow,
        u_clampHigh: typeof clampHigh !== 'undefined' ? clampHigh : clampLow,
        u_noDataValue: noDataValue,
        u_colorTexture: this.colorTexture
      };
    }
  }, {
    key: "initModels",
    value: function initModels(callbackModel) {
      var _this = this;

      var _ref2 = this.layer.getLayerConfig(),
          _ref2$mask = _ref2.mask,
          mask = _ref2$mask === void 0 ? false : _ref2$mask,
          _ref2$maskInside = _ref2.maskInside,
          maskInside = _ref2$maskInside === void 0 ? true : _ref2$maskInside,
          rampColorsData = _ref2.rampColorsData,
          rampColors = _ref2.rampColors;

      var source = this.layer.getSource();
      var createTexture2D = this.rendererService.createTexture2D;
      this.texture = createTexture2D({
        height: 0,
        width: 0
      });
      source.data.images.then(function (imageData) {
        _this.texture = createTexture2D({
          data: imageData[0],
          width: imageData[0].width,
          height: imageData[0].height
        });

        _this.layerService.reRender();
      });
      var rampImageData = rampColorsData ? rampColorsData : generateColorRamp(rampColors);
      this.colorTexture = createTexture2D({
        data: rampImageData.data,
        width: rampImageData.width,
        height: rampImageData.height,
        flipY: false
      });
      this.layer.buildLayerModel({
        moduleName: 'RasterImage',
        vertexShader: ImageVert,
        fragmentShader: ImageFrag,
        triangulation: RasterImageTriangulation,
        primitive: gl.TRIANGLES,
        depth: {
          enable: false
        },
        blend: this.getBlend(),
        stencil: getMask(mask, maskInside)
      }).then(function (model) {
        callbackModel([model]);
      }).catch(function (err) {
        console.warn(err);
        callbackModel([]);
      });
    }
  }, {
    key: "clearModels",
    value: function clearModels() {
      var _this$texture, _this$colorTexture;

      (_this$texture = this.texture) === null || _this$texture === void 0 ? void 0 : _this$texture.destroy();
      (_this$colorTexture = this.colorTexture) === null || _this$colorTexture === void 0 ? void 0 : _this$colorTexture.destroy();
    }
  }, {
    key: "buildModels",
    value: function buildModels(callbackModel) {
      this.initModels(callbackModel);
    }
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {
      this.styleAttributeService.registerStyleAttribute({
        name: 'uv',
        type: AttributeType.Attribute,
        descriptor: {
          name: 'a_Uv',
          buffer: {
            usage: gl.DYNAMIC_DRAW,
            data: [],
            type: gl.FLOAT
          },
          size: 2,
          update: function update(feature, featureIdx, vertex) {
            return [vertex[3], vertex[4]];
          }
        }
      });
    }
  }, {
    key: "updateColorTexture",
    value: function updateColorTexture() {
      var createTexture2D = this.rendererService.createTexture2D;

      var _ref3 = this.layer.getLayerConfig(),
          rampColors = _ref3.rampColors;

      var imageData = generateColorRamp(rampColors);
      this.colorTexture = createTexture2D({
        data: imageData.data,
        width: imageData.width,
        height: imageData.height,
        flipY: false
      });
    }
  }]);

  return ImageDataModel;
}(BaseModel);

export { ImageDataModel as default };